import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';
import { Logo } from '@/components/brand/Logo';
import { useMe } from '@/features/auth/session-context';
import { NAV_ICONS } from '@/features/navigation/nav-icons';
import { PAGES, visibleNavigation } from '@/features/navigation/pages';
import { navCount, useNavCounts } from '@/features/shell/api';
import { UserMenu } from './shell/UserMenu';
import shellStyles from './shell/Shell.module.css';
import styles from './Sidebar.module.css';

/** Sidebar grouped like Admin v2 for the active role, filtered by the API's permissions. */
export function Sidebar() {
  const { t } = useTranslation();
  const me = useMe();
  const { data: counts } = useNavCounts();
  const groups = visibleNavigation(me.activeRole.key, me.permissions);

  return (
    <aside className={styles.sidebar}>
      <div className={styles.brand}>
        <Logo className={styles.logo} />
      </div>
      <nav className={styles.nav} aria-label={t('shell.mainNav')}>
        {groups.map((group, i) => (
          <div key={group.heading ?? `top-${i}`} className={styles.group}>
            {group.heading && <p className={styles.heading}>{group.heading}</p>}
            <ul>
              {group.pages.map((id) => {
                const page = PAGES[id];
                const Icon = NAV_ICONS[id];
                const count = navCount(counts, id);
                return (
                  <li key={id}>
                    <NavLink
                      to={page.path}
                      end={page.path === '/patients'}
                      className={({ isActive }) =>
                        [styles.item, isActive && styles.active]
                          .filter(Boolean)
                          .join(' ')
                      }
                    >
                      <Icon size={18} aria-hidden="true" />
                      <span>{page.label}</span>
                      {count > 0 && (
                        <span
                          className={shellStyles.navCount}
                          aria-label={`${count} waiting`}
                        >
                          {count}
                        </span>
                      )}
                    </NavLink>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </nav>
      <UserMenu />
    </aside>
  );
}
